interface AppConfigInterface {
  accountServer: string;
  bblServer: string;
  s3Bucket: string;
}

export const appConfig = (): AppConfigInterface => {
  if (process.env.REACT_APP_ENVIRONMENT === 'ALPHA') {
    return {
      accountServer: process.env.REACT_APP_ALPHA_ACCOUNT_SERVER
        ? process.env.REACT_APP_ALPHA_ACCOUNT_SERVER
        : 'http://localhost:10000/',
      bblServer: process.env.REACT_APP_ALPHA_BBL_SERVER
        ? process.env.REACT_APP_ALPHA_BBL_SERVER
        : 'http://localhost:8080/',
      s3Bucket: process.env.REACT_APP_ALPHA_BBL_S3_BUCKET
        ? process.env.REACT_APP_ALPHA_BBL_S3_BUCKET
        : 'https://bigbang-public.s3.ap-southeast-1.amazonaws.com/bigbanglab/',
    };
  }

  return {
    accountServer: process.env.REACT_APP_ACCOUNT_SERVER
      ? process.env.REACT_APP_ACCOUNT_SERVER
      : 'http://localhost:10000/',
    bblServer: process.env.REACT_APP_BBL_SERVER
      ? process.env.REACT_APP_BBL_SERVER
      : 'http://localhost:8080/',
    s3Bucket: process.env.REACT_APP_BBL_S3_BUCKET
      ? process.env.REACT_APP_BBL_S3_BUCKET
      : 'https://bigbang-public.s3.ap-southeast-1.amazonaws.com/bigbanglab/',
  };
};
